import { useQuery } from 'react-query'

import { CacheKeys } from '../../helpers/cacheKeys'
import { getSafetyScoreForUser } from '../../models/compliance'

export function useSafetyScore(userId: string, { enabled }: { enabled?: boolean }) {
  const { data } = useQuery(`${CacheKeys.SAFETY_SCORE}-${userId}`, () => getSafetyScoreForUser(userId), {
    enabled: enabled && !!userId,
    refetchOnWindowFocus: false,
    retry: false,
  })

  return {
    safetyScore: data,
  }
}
